/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ListingsIndexRouteImport } from './routes/listings/index'
import { Route as AssessmentsIndexRouteImport } from './routes/assessments/index'
import { Route as ListingListingIdIndexRouteImport } from './routes/listing.$listingId/index'
import { Route as AssessmentsAssessmentIdIndexRouteImport } from './routes/assessments/$assessmentId/index'
import { Route as AssessmentsAssessmentIdCompareComparisonIdRouteImport } from './routes/assessments/$assessmentId/compare.$comparisonId'

const AssessmentsLazyRouteImport = createFileRoute('/assessments')()

const AssessmentsLazyRoute = AssessmentsLazyRouteImport.update({
  id: '/assessments',
  path: '/assessments',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/assessments.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ListingsIndexRoute = ListingsIndexRouteImport.update({
  id: '/listings/',
  path: '/listings/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssessmentsIndexRoute = AssessmentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AssessmentsLazyRoute,
} as any)
const ListingListingIdIndexRoute = ListingListingIdIndexRouteImport.update({
  id: '/listing/$listingId/',
  path: '/listing/$listingId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssessmentsAssessmentIdIndexRoute =
  AssessmentsAssessmentIdIndexRouteImport.update({
    id: '/$assessmentId/',
    path: '/$assessmentId/',
    getParentRoute: () => AssessmentsLazyRoute,
  } as any)
const AssessmentsAssessmentIdCompareComparisonIdRoute =
  AssessmentsAssessmentIdCompareComparisonIdRouteImport.update({
    id: '/$assessmentId/compare/$comparisonId',
    path: '/$assessmentId/compare/$comparisonId',
    getParentRoute: () => AssessmentsLazyRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/assessments': typeof AssessmentsLazyRouteWithChildren
  '/assessments/': typeof AssessmentsIndexRoute
  '/listings': typeof ListingsIndexRoute
  '/assessments/$assessmentId': typeof AssessmentsAssessmentIdIndexRoute
  '/listing/$listingId': typeof ListingListingIdIndexRoute
  '/assessments/$assessmentId/compare/$comparisonId': typeof AssessmentsAssessmentIdCompareComparisonIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/assessments': typeof AssessmentsIndexRoute
  '/listings': typeof ListingsIndexRoute
  '/assessments/$assessmentId': typeof AssessmentsAssessmentIdIndexRoute
  '/listing/$listingId': typeof ListingListingIdIndexRoute
  '/assessments/$assessmentId/compare/$comparisonId': typeof AssessmentsAssessmentIdCompareComparisonIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/assessments': typeof AssessmentsLazyRouteWithChildren
  '/assessments/': typeof AssessmentsIndexRoute
  '/listings/': typeof ListingsIndexRoute
  '/assessments/$assessmentId/': typeof AssessmentsAssessmentIdIndexRoute
  '/listing/$listingId/': typeof ListingListingIdIndexRoute
  '/assessments/$assessmentId/compare/$comparisonId': typeof AssessmentsAssessmentIdCompareComparisonIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/assessments'
    | '/assessments/'
    | '/listings'
    | '/assessments/$assessmentId'
    | '/listing/$listingId'
    | '/assessments/$assessmentId/compare/$comparisonId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/assessments'
    | '/listings'
    | '/assessments/$assessmentId'
    | '/listing/$listingId'
    | '/assessments/$assessmentId/compare/$comparisonId'
  id:
    | '__root__'
    | '/'
    | '/assessments'
    | '/assessments/'
    | '/listings/'
    | '/assessments/$assessmentId/'
    | '/listing/$listingId/'
    | '/assessments/$assessmentId/compare/$comparisonId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AssessmentsLazyRoute: typeof AssessmentsLazyRouteWithChildren
  ListingsIndexRoute: typeof ListingsIndexRoute
  ListingListingIdIndexRoute: typeof ListingListingIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/assessments': {
      id: '/assessments'
      path: '/assessments'
      fullPath: '/assessments'
      preLoaderRoute: typeof AssessmentsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/listings/': {
      id: '/listings/'
      path: '/listings'
      fullPath: '/listings'
      preLoaderRoute: typeof ListingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assessments/': {
      id: '/assessments/'
      path: '/'
      fullPath: '/assessments/'
      preLoaderRoute: typeof AssessmentsIndexRouteImport
      parentRoute: typeof AssessmentsLazyRoute
    }
    '/listing/$listingId/': {
      id: '/listing/$listingId/'
      path: '/listing/$listingId'
      fullPath: '/listing/$listingId'
      preLoaderRoute: typeof ListingListingIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assessments/$assessmentId/': {
      id: '/assessments/$assessmentId/'
      path: '/$assessmentId'
      fullPath: '/assessments/$assessmentId'
      preLoaderRoute: typeof AssessmentsAssessmentIdIndexRouteImport
      parentRoute: typeof AssessmentsLazyRoute
    }
    '/assessments/$assessmentId/compare/$comparisonId': {
      id: '/assessments/$assessmentId/compare/$comparisonId'
      path: '/$assessmentId/compare/$comparisonId'
      fullPath: '/assessments/$assessmentId/compare/$comparisonId'
      preLoaderRoute: typeof AssessmentsAssessmentIdCompareComparisonIdRouteImport
      parentRoute: typeof AssessmentsLazyRoute
    }
  }
}

interface AssessmentsLazyRouteChildren {
  AssessmentsIndexRoute: typeof AssessmentsIndexRoute
  AssessmentsAssessmentIdIndexRoute: typeof AssessmentsAssessmentIdIndexRoute
  AssessmentsAssessmentIdCompareComparisonIdRoute: typeof AssessmentsAssessmentIdCompareComparisonIdRoute
}

const AssessmentsLazyRouteChildren: AssessmentsLazyRouteChildren = {
  AssessmentsIndexRoute: AssessmentsIndexRoute,
  AssessmentsAssessmentIdIndexRoute: AssessmentsAssessmentIdIndexRoute,
  AssessmentsAssessmentIdCompareComparisonIdRoute:
    AssessmentsAssessmentIdCompareComparisonIdRoute,
}

const AssessmentsLazyRouteWithChildren = AssessmentsLazyRoute._addFileChildren(
  AssessmentsLazyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AssessmentsLazyRoute: AssessmentsLazyRouteWithChildren,
  ListingsIndexRoute: ListingsIndexRoute,
  ListingListingIdIndexRoute: ListingListingIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
